import { t } from "@lingui/macro";
import { I18n } from "@lingui/core";

import { FieldName } from "..";

export default (i18n: I18n) => ({
  iban: {
    name: FieldName.iban,
    label: "IBAN",
    placeholder: `${i18n._(
      t({
        id: "placeholder.example",
        message: "e.g.",
      })
    )} MC93 2005 2222 1001 1223 3M44 555`,
    instructions: i18n._(
      t({
        id: "fields-config.iban.instructions",
        message: "International Bank Account Number",
      })
    ),
  },
  local: [
    {
      name: FieldName.bankCode,
      label: "Code Banque",
      placeholder: `${i18n._(
        t({ id: "placeholder.example", message: "e.g." })
      )} 20052`,
      instructions: i18n._(
        t({
          id: "fields-config.bank-code.instructions",
          message: "Bank code",
        })
      ),
    },
    {
      name: FieldName.branchCode,
      label: "Code Guichet",
      placeholder: `${i18n._(
        t({ id: "placeholder.example", message: "e.g." })
      )} 22210`,
      instructions: i18n._(
        t({
          id: "fields-config.branch-code.instructions",
          message: "Branch code",
        })
      ),
    },
    {
      name: FieldName.accountNumber,
      label: "Numéro de Compte PLUS Clé RIB",
      placeholder: `${i18n._(
        t({
          id: "placeholder.example",
          message: "e.g.",
        })
      )} 0112233M445 55`,
      instructions: i18n._(
        t({
          id: "fields-config.account-number.instructions",
          message: "Account number",
        })
      ),
    },
  ],
  primaryBankDetailsFields: [FieldName.iban],
  secondaryBankDetailsField: [
    FieldName.bankCode,
    FieldName.branchCode,
    FieldName.accountNumber,
  ],
});
